/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewFindingSourceType = {
    Firehose: 'firehose',
    Asm: 'asm'
} as const;
export type CRSFSecReviewFindingSourceType = typeof CRSFSecReviewFindingSourceType[keyof typeof CRSFSecReviewFindingSourceType];


export function CRSFSecReviewFindingSourceTypeFromJSON(json: any): CRSFSecReviewFindingSourceType {
    return CRSFSecReviewFindingSourceTypeFromJSONTyped(json, false);
}

export function CRSFSecReviewFindingSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewFindingSourceType {
    return json as CRSFSecReviewFindingSourceType;
}

export function CRSFSecReviewFindingSourceTypeToJSON(value?: CRSFSecReviewFindingSourceType | null): any {
    return value as any;
}

